/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class LanguageEntity extends Entity {
  id: string = '';
  name: string | null = null;
  languageCEFR?: string | null = null;
  languageProficiency?: string | null = null;
  languageSkill?: string | null = null;
  static override key = 'Language';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'Language' in input
    ) {
      const { Language: wrapped, ...rest } = input as {
        Language: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}